import { images } from "../constants";

const downloadApp = {  
    sub: "Download Our App",
    heading: "Download our SwiftRide App Today",
    content: "Book your ride anytime, anywhere with ease. Enjoy the convenience of quick taxi booking, live tracking, and secure payments all in one app. Experience a smoother, more comfortable journey with SwiftRide.",
    buttons: [
        {
            id: 1,
            image: images.playStoreBtn,
            alt: "Download on Google Play",
            link: "#"
        },
        {
            id: 2,
            image: images.appStoreBtn,
            alt: "Download on the App Store",
            link: "#"
        }
    ],
    image: images.mobileApp
}

export default downloadApp;